import React, { useState, useEffect } from "react";

import axios from "axios";
import { server } from "../../../utills/utils";

import styled from "styled-components";

const Container = styled.div`
  width: 27%;
  border-radius: 5px;
  margin: 0 2% 0 0;
  padding: 0 2%;
`;
const SubButton = styled.button`
  padding: 5px 20px;
  cursor: pointer;
  border-radius: 5px;
  background: white;
  border: 1px solid #eee;
`;
const CatName = styled.h3``;

function Category(props) {
  const { _id, name, subCategories } = props.category;

  return (
    <Container>
      <CatName>{name}</CatName>
      {subCategories.map((subCat) => {
        return <p>{subCat.name}</p>;
      })}
      <SubButton>Add new sub category</SubButton>
    </Container>
  );
}

export default Category;
